import Vue from 'vue';
import Router from 'vue-router';

import Index from '@/components/Index';
import Team from '@/components/Team';
import PrivacyPolicy from '@/components/PrivacyPolicy';
import Imprint from '@/components/Imprint';
import NotFound from '@/components/NotFound';

Vue.use(Router);

export default new Router({
  saveScrollPosition: false,
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: Index,
    },
    {
      path: '/team',
      name: 'team',
      component: Team,
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPolicy,
    },
    {
      path: '/imprint',
      name: 'imprint',
      component: Imprint,
    },
    {
      path: '*',
      name: 'not-found',
      component: NotFound,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js